// Import Types
import { Award, AwardById, DataWithPaging } from 'types';
// Import Helpers
import { generateCleanUrlParams } from 'services/Helpers';
// Import Configs
import { CRMRequestService, postCancelableRequest, getCancelableRequest } from './http.config';

interface GetBonusByIdRequestParams {
    bonusId: string | number;
    pointInTime?: Nullable<string>;
}

const BonusHttpService = {
    getBonusList: () => {
        return postCancelableRequest<DataWithPaging<Award>>({
            requestService: CRMRequestService,
            endpointPath: ({ isIncludeExpired = false, isIncludeDeleted = false }) =>
                `/Bonus/List${generateCleanUrlParams({ isIncludeExpired, isIncludeDeleted })}`,
        });
    },
    getBonusById: () => {
        return getCancelableRequest<AwardById, GetBonusByIdRequestParams>({
            requestService: CRMRequestService,
            endpointPath: ({ bonusId, pointInTime }) =>
                `/Bonus/Get${generateCleanUrlParams({ id: bonusId, pointInTime })}`,
        });
    },
    getBonusByIds: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ isIncludeExpired = false, isIncludeDeleted = false }) =>
                `/Bonus/GetByIds${generateCleanUrlParams({ isIncludeExpired, isIncludeDeleted })}`,
        });
    },
};

export default BonusHttpService;
